import cn from 'classnames';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { ButtonTransparent, ModalSmall } from 'library/components/common';
import { closeNotifyModal } from 'library/redux/modal';
import * as st from './ModalInfo.module.scss';

const ModalInfo = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const data = useAppSelector((state) => state.modals.notifyProps);

  const handleConfirm = (withOnConfirm: boolean) => {
    enableScroll();
    dispatch(closeNotifyModal());
    data.confirm && withOnConfirm && data.confirm();
  };

  return (
    <ModalSmall
      needClose={data.needClose}
      isOpen
      title={data.title}
      overlayClassName={st.overlay}
      onRequestClose={() => handleConfirm(!data.isOnConfirmShouldNotWorkOnCloseModal)}
      className={cn(st.modal, data.className)}
      titleClassName={st.title}
      modalBodyClassName={st.body}
    >
      <div className={cn(st.message, data?.fullWidthText && st.fullWidthText, data?.textClassName)}>
        <span>{data.text}</span>
      </div>
      <div className={cn(st.buttons, data.buttonsClassName)}>
        <div className={cn(st.buttons__button, data.buttonClassName)}>
          <ButtonTransparent
            handler={() => handleConfirm(true)}
            text={data.confirmText}
            theme="blue"
          />
        </div>
      </div>
    </ModalSmall>
  );
};

export default ModalInfo;
